import React from "react";
//#region types
import { ResultItemProps } from "models/propTypes/resultItemPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid, ListItemAvatar } from "@mui/material";
import ProfileImage from "../profile/profileImage";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { isUndefined } from "util";

const ResultItem: React.FC<ResultItemProps> = (props) => {
  const { isSelected } = props;
  const onClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!isSelected) props.onClickHandler(props.item);
  };

  const onRemoveClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (props.onRemoveHandler) props.onRemoveHandler(props.item.id);
  };

  return (
    <Grid
      item
      container
      className={clsx(cssExports.searchResultItem, isSelected ? cssExports.selected : "")}
      alignItems="center"
      onClick={onClick}
      direction={"row"}
      columnSpacing={2}
      wrap="nowrap"
    >
      {!props.hideIcon && (
        <Grid item>
          {props.item.avatar && !isSelected ? (
            <ListItemAvatar>
              <div className={cssExports.listItemAvatar}>
                <ProfileImage {...props.item.avatar} />
              </div>
            </ListItemAvatar>
          ) : (
            <Grid item className={cssExports.icon}>
              <Icon
                icon={
                  isSelected
                    ? IconDefinitionConstants.WCheck
                    : props.item.icon
                    ? props.item.icon
                    : IconDefinitionConstants.WHashtag
                }
              />
            </Grid>
          )}
        </Grid>
      )}

      {props.getItemTemplate ? (
        props.getItemTemplate(props.item.data)
      ) : (
        <Grid item xs className={cssExports.searchResultTextContainer}>
          <Grid item container direction="column">
            <Grid item className={cssExports.searchResultText}>
              {props.item.value}
            </Grid>
            <Grid item className={cssExports.searchResultDescription}>
              {props.item.description}
            </Grid>
          </Grid>
        </Grid>
      )}

      {isSelected && !isUndefined(props.canRemove) && props.canRemove ? (
        <>
          {props.additionalContentOnSelection ? (
            <Grid item xs={props.additionalContentColumnCount}>
              {props.additionalContentOnSelection}
            </Grid>
          ) : (
            ""
          )}
          <Grid item className={cssExports.itemRemoveIcon} onClick={onRemoveClick}>
            <Icon icon={IconDefinitionConstants.WTimes} />
          </Grid>
        </>
      ) : (
        ""
      )}
    </Grid>
  );
};

export default ResultItem;
